module.exports = __webpack_public_path__ + "static/media/background.b9967c62.jpg";